
import { UserPage } from "./UserPage";

export function HomePage(){
    return(
        <div>
            <UserPage/>
        </div>
    )
}